// npm packages
import React from 'react';

// components
import sectionList from '@/constants/sectionList';
import HomepageFiveProductCarousel from './Section/HomepageFiveProductCarousel';
import HomepageHeroBannerCarousel from './Slider/HomepageHeroBannerCarousel';
import HomepageMarketingBannerCarousel from './Slider/HomepageMarketingBannerCarousel';
import HomepageBrandCarousel from './Section/HomepageBrandCarousel';
import HomepageOtherBrandCarousel from './Section/HomepageOtherBrandCarousel';
import HomepageCategoryCarousel from './Section/HomepageCategoryCarousel';
import HomepageThreeProductCarousel from './Section/HomepageThreeProductCarousel';
import JustForYouCarousel from './Section/JustForYouCarousel';
import RecentlyViewedCarousel from './Section/RecentlyViewedCarousel';
import PdpSimilarProductCarousel from './Section/PdpSimilarProductCarousel';
import HomepageSingleMediaBannerCarousel from './Section/HomepageSingleMediaBannerCarousel';
import PdpFrequentlyBoughtTogetherProductCarousel from './Section/PdpFrequentlyBoughtTogetherProductCarousel';
import CampaignHeroBannerCarousel from './Slider/CampaignHeroBannerCarousel';
import CampaignProductCarousel from './Section/CampaignProductCarousel';
import CampaignPopularDeals from './Section/CampaignPopularDeals';
import CampaignCategoryProductCarousel from './Section/CampaignCategoryProductCarousel';

function SectionDynamicGroup({
  section,
  hasParentBG = false,
  hasParentTimer = false,
  isGroupSection = false,
}) {
  const sections = () => {
    switch (section?.ui_component_name) {
      case sectionList.HOMEPAGE_HERO_BANNER_CAROUSEL:
        return <HomepageHeroBannerCarousel section={section} />;
      case sectionList.HOMEPAGE_MARKETING_BANNER_CAROUSEL:
        return <HomepageMarketingBannerCarousel section={section} />;
      case sectionList.HOMEPAGE_CATEGORY_CAROUSEL:
        return <HomepageCategoryCarousel section={section} />;
      case sectionList.HOMEPAGE_FIVE_PRODUCT_CAROUSEL:
        return <HomepageFiveProductCarousel section={section} />;
      case sectionList.HOMEPAGE_BRAND_CAROUSEL:
        return <HomepageBrandCarousel section={section} />;
      case sectionList.HOMEPAGE_OTHER_BRAND_CAROUSEL:
        return <HomepageOtherBrandCarousel section={section} />;
      case sectionList.HOMEPAGE_THREE_PRODUCT_CAROUSEL:
        return <HomepageThreeProductCarousel section={section} />;
      case sectionList.HOMEPAGE_SINGLE_MEDIA_BANNER_CAROUSEL:
        return <HomepageSingleMediaBannerCarousel section={section} />;
      case sectionList.JUST_FOR_YOU_CAROUSEL:
        return (
          <JustForYouCarousel section={section} hasParentBG={hasParentBG} />
        );
      case sectionList.RECENTLY_VIEWED_CAROUSEL:
        return (
          <RecentlyViewedCarousel section={section} hasParentBG={hasParentBG} />
        );
      case sectionList.PDP_FREQUENTLY_BOUGHT_TOGETHER_PRODUCT_CAROUSEL:
        return (
          <PdpFrequentlyBoughtTogetherProductCarousel
            section={section}
            hasParentBG={hasParentBG}
          />
        );
      case sectionList.PDP_SIMILAR_PRODUCT_CAROUSEL:
        return (
          <PdpSimilarProductCarousel
            section={section}
            hasParentBG={hasParentBG}
          />
        );
      case sectionList.PDP_CUSTOMER_RATING:
        return <p>TODO: Rating Section Will Be Here</p>;
      case sectionList.CAMPAIGN_HERO_BANNER_CAROUSEL:
        return (
          <CampaignHeroBannerCarousel
            section={section}
            hasParentBG={hasParentBG}
          />
        );
      case sectionList.CAMPAIGN_PRODUCT_CAROUSEL:
        return (
          <CampaignProductCarousel
            section={section}
            hasParentBG={hasParentBG}
            hasParentTimer={hasParentTimer}
            isGroupSection={isGroupSection}
          />
        );
      case sectionList.CAMPAIGN_CATEGORY_PRODUCT_CAROUSEL:
        return (
          <CampaignCategoryProductCarousel
            section={section}
            hasParentBG={hasParentBG}
            hasParentTimer={hasParentTimer}
            isGroupSection={isGroupSection}
          />
        );
      case sectionList.CAMPAIGN_POPULAR_DEALS:
        return (
          <CampaignPopularDeals
            section={section}
            hasParentBG={hasParentBG}
            hasParentTimer={hasParentTimer}
          />
        );
      default:
        return null;
    }
  };

  return sections();
}

export default SectionDynamicGroup;
